import React from "react";
import { Link, type LinkProps } from "@jasperlabs/ui";

type UrlOrFile =
	| {
			type: "url" | "file";
			url: string | null;
			fileUrl: string | null;
	  }
	| {
			type: "url" | "file";
			url: string | null;
			fileUrl: string | null;
	  };

function SanityUrlOrFileLink({
	urlOrFile,
	children,
	missingDestinationFallback = children,
	...props
}: Omit<LinkProps<"a">, "href" | "children"> & {
	children?: React.ReactNode;
	missingDestinationFallback?: React.ReactNode;
	urlOrFile: UrlOrFile;
}) {
	const { type, url, fileUrl } = urlOrFile;
	const href = (type === "url" ? url : fileUrl)?.trim();

	if (!href) {
		return <>{missingDestinationFallback}</>;
	}

	return (
		<Link href={href} target="_blank" {...props}>
			{children}
		</Link>
	);
}

export default SanityUrlOrFileLink;
